import styles from './Segmented.module.css'

export interface SegmentOption<T extends string> {
  value: T
  label: string
}

interface Props<T extends string> {
  options: SegmentOption<T>[]
  value: T
  onChange: (value: T) => void
  ariaLabel: string
  /**
   * Переключатель во всю ширину, половина на половину.
   *
   * Так он нарисован в диалоге автовывода (Auto-Withdrawals 4:44343,
   * сегменты 266+266 в поле 544): выбор типа правила — главное
   * решение окна, и по ширине оно равно полям под ним. Узкий
   * переключатель по содержимому остаётся у фильтров, где он один
   * из многих.
   */
  wide?: boolean
}

/**
 * Сегментный переключатель: период графика, тип операции, фильтр.
 *
 * Роль `tablist`, а не набор кнопок: для читалки это один элемент
 * с выбранным значением, а не пять независимых кнопок подряд.
 */
export function Segmented<T extends string>({
  options, value, onChange, ariaLabel, wide,
}: Props<T>) {
  return (
    <div className={wide ? `${styles.group} ${styles.wide}` : styles.group}
         role="tablist" aria-label={ariaLabel}>
      {options.map((option) => {
        const active = option.value === value
        return (
          <button
            key={option.value}
            type="button"
            role="tab"
            aria-selected={active}
            className={active ? `${styles.item} ${styles.active}` : styles.item}
            onClick={() => onChange(option.value)}
          >
            {option.label}
          </button>
        )
      })}
    </div>
  )
}
